const speedshoppingTNC = {
  header: "TERMS AND CONDITIONS: MTN SPEED SHOPPING LOYALTY SCHEME ",
  body: [
    {
      details: `Welcome to Speed Shopping, a loyalty initiative for the Youth Segment on myMTN App. In your decision to use the services, you are deemed to have accepted the Terms and Conditions pertaining to these services as per below or as may be revised from time to time, which is, for an indefinite period and you understand and agree that you are bound by such terms till the time you stop using the services. We reserve the right to change these terms & conditions from time to time without any obligation to inform you and it is your responsibility to look through them as often as possible. `,
    },
    {
      title: `GENERAL TERMS`,
      details: `Speed Shopping promo is a point-based initiative for the youth segment`,
    },
    {
      title: ``,
      details: `Speed shopping Promo is exclusive to MTN Pulse customers only.`,
    },
    {
      title: ``,
      details: `Customer gains 1 point for every five pesewas spent (GHC 0.05) on mashup via myMTN Application.`,
    },
    {
      title: ``,
      details: `Accrued points are not transferable to another MTN subscriber.`,
    },
    {
      title: ``,
      details: `Usage of mashup bundles do not accrue points.`,
    },
    {
      title: ``,
      details: `Usage from main account do not accrue points.`,
    },
    {
      title: `REGISTRATION AND SERVICE`,
      details: `There is no registration required for participants.`,
    },
    {
      title: ``,
      details: `Customers can check their accumulated points by visiting the Offers tab on the Pulse Section of myMTN App.`,
    },
    {
      title: ``,
      details: `Participants must be 18 years and above.`,
    },
    {
      title: ``,
      details: `By activating the service, a customer agrees to be bound by these Terms and Conditions. `,
    },
    {
      title: ``,
      details: `MTN reserves the right to amend or revise the Terms and Conditions at any time without an obligation to notify customers of such amendments. Any amendment or variation of these terms shall be available to customers via the MTN Pulse App. We advise you to periodically review these terms and conditions. `,
    },
    {
      title: ``,
      details: `MTN provides the Promo on an "as is" and "as available" basis, in the hope that you find it useful. MTN does not warrant that the Promo will be free of errors, faults or interruptions and we shall not be liable to you in connection with (but not limited to): `,
    },
    {
      title: ``,
      details: `- any cause beyond our reasonable control; `,
    },
    {
      title: ``,
      details: `- any failure or delay in the use of or inability to use any component of the service; `,
    },
    {
      title: ``,
      details: `- any loss, claim or damage including loss or corruption of data howsoever arising.`,
    },
    {
      title: `SUBSCRIPTION CHARGES`,
      details: `Subscription of service is free.”
      `,
    },
    {
      title: `PROMOTION DURATION`,
      details: `The point building period for this promo is scheduled to start on November 15, 2023 ending December 15, 2023 (the “Promotion Period”)..`,
    },
    {
      title: `REWARDING SCHEME`,
      details: `At the end of the stipulated period, winners will be selected per the number of points accrued via mashup either by MoMo or Airtime payment channels. The customers with the highest points will be notified by a message on the Pulse App and by phone call to confirm their selection to participate in the online shopping spree. In case of a tie, the customer with the highest tenure as an MTN customer takes the prize. If it ties at the tenure level, the customer with the highest usage for the past 10 days prior to the promo takes the prize.`,
    },
    {
      title: ``,
      details: `Winners will be given two (2) days notification prior to the date for the shopping spree. In the event that the winners selected are not available to participate in the virtual shopping spree, the prize will be allocated to the next customer in order of rank.`,
    },
    {
      title: ``,
      details: `The duration of the promotion may be extended whenever business deems it appropriate.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to swap prizes if a particular prize is not applicable in a particular region.`,
    },
    {
      title: `ELIGIBILTY RULES`,
      details: `All prepaid customers within the Pulse Age limit (15-35 years).`,
    },
    {
      title: `ABUSE AND DISQUALIFICATION`,
      details: `MTN reserves the right to disqualify a frontrunner when it is proven that the frontrunner used a fraudulent means to participate in the promo.`,
    },
    {
      title: `PERSONAL DATA PROTECTION`,
      details: `By enjoying this loyalty scheme, the Customer expressly agree that personal data which they supply shall be processed by MTN for the purpose of executing the loyalty scheme and also for the purpose of publicizing the scheme and MTN. It is hereby specified that MTN guarantees that publicity, entailing the sharing with third parties of personal data supplied as a result of participation in the loyalty scheme, (including through television, the press, leaflets and other means and format of communication) shall be made only with respect to the participants of the scheme and will only indicate the given names and surnames of the participants, their images and voices, made for the sole purpose of publicity connected to the loyalty scheme). Participation in the loyalty scheme shall be deemed as participants express consent for the use of this data in the manner herein defined.`,
    },
    {
      title: ``,
      details: `Notwithstanding the above, personal date of the winning participants will be retained by MTN in accordance with the law.`,
    },
    {
      title: ``,
      details: ` Notwithstanding the above, personal data of the participation will be retained by MTN in accordance with the law. MTN respects the privacy of Participants of this loyalty scheme and accordingly personal data collected during this promo will be treated as private and confidential and in accordance with Data Protection laws of Ghana.`,
    },
    {
      title: ``,
      details: `MTN respects the privacy of Participants of this Promo and accordingly personal data collected during this promo will be treated as private and confidential and in accordance with Data Protection laws of Ghana.`,
    },
    {
      title: `GOVERNING LAW & AMENDMENTS`,
      details: `This Promotion is organized under and governed by the laws and statutes of Ghana. `,
    },
    {
      title: ``,
      details: `These Terms & Conditions are valid during the Promotion Period until amended or suspended by MTN.`,
    },
  ],
};

export default speedshoppingTNC;
